import { create } from 'zustand';

/**
 * Stav toggle „vizualizace zámků" per legacy okno (layerId). Phoenix-owned UI stav — skutečnou
 * vizualizaci provádí Magic uvnitř single-form iframu po `window/toggle-locks`.
 */
interface LockVizStoreState {
  readonly byLayer: Readonly<Record<string, boolean>>;
  readonly setEnabled: (layerId: string, enabled: boolean) => void;
}

export const useLockVizStore = create<LockVizStoreState>((set) => ({
  byLayer: {},
  setEnabled: (layerId, enabled) => set((s) => ({ byLayer: { ...s.byLayer, [layerId]: enabled } })),
}));
